<template>
    <v-tab-item :value="Analyzer.value">
        <v-container>
            <top-image :tit="Analyzer.text" bgImage="/images/sub/product/analyzer-bg.jpg" image="/images/sub/product/analyzer-img.png">
                <p class="page-text mb-6 mb-lg-20">
                    We specialize in the design, manufacturing, and commissioning of Analyzer Package System for various industries, including oil and gas, petrochemical, mining, power generation, and many more.
                </p>
                <p class="page-text mb-6 mb-lg-20">
                    Analyzer Package System includes analyzer shelter, cabinet, and rack that are designed to accommodate various types of analyzers such as Gas chromatographs, IR analyzer, NIR analyzer, Total sulfur analyzer, and Analyzers for physical properties. We carefully select the analyzers from reputable manufacturers to ensure the highest quality and performance.
                </p>
                <p class="page-text mb-6 mb-lg-20">
                    Our analyzer package system also includes a sampling system to prepare samples for analysis, HVAC (Heating, Ventilation and Air Conditioning) to control the temperature and humidity inside the shelter, and safety systems to ensure the safe operation of the equipment.
                </p>
                <p class="page-text mb-6 mb-lg-20">
                    Our team of experienced engineers work closely with customers to understand their unique requirements and develop custom solutions that are tailored to their specific needs.
                </p>
                <p class="page-text">
                    We also provide expert technical support and maintenance services to ensure that your system is always running at peak performance.
                </p>
            </top-image>
        </v-container>
    </v-tab-item>
</template>

<script>
import TopImage from "@/components/dumb/top-image.vue";
import { Product_TABS } from "@/assets/variables";
const { Analyzer } = Product_TABS;
export default {
    components: {
        TopImage,
    },
    data() {
        return {
            Analyzer,
        };
    },
};
</script>

<style scoped></style>
